
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {
        ApplicationActions,
        ApplicationViewModel,
        IdentityValueViewModel,
        QualificationRequirementViewModel,
        QualificationViewModel,
        RequirementFulfillmentViewModel,
        RequirementsClient, 
        SpecialityType,
        ValidityStatus
    } from "@/api-client";
    import {BvTableFieldArray} from "bootstrap-vue"
    import RequirementsTable from "@/features/applications/components/RequirementsTable.vue";
    import TableItem from "@/features/applications/components/TableItem";
    import AddQualificationModal from "@/features/documents/qualifications/components/AddQualificationModal.vue";
    import Loader from "@/features/shared/components/Loader";
    import {ls} from "@/CultureService";
    import {formatDate} from "@/formatting/dateFormatter";
    import ValidityStatusBadge from "@/features/shared/components/ValidityStatusBadge.vue";
    import Badge from "@/features/shared/components/Badge.vue";


    class QualificationTableItem implements TableItem {
        speciality: string;
        specialityTypeName: string;
        id: string;
        specialityType: SpecialityType;
        issuedOn: Date | null;
        validUntil: Date | null;
        validity: ValidityStatus;
        isDeleted: boolean;

        constructor(qualification: QualificationViewModel) {
            this.speciality = qualification.speciality;
            this.specialityTypeName = qualification.specialityTypeName;
            this.id = qualification.id;
            this.specialityType = qualification.specialityType;
            this.issuedOn = qualification.issuedOn || null;
            this.validUntil = qualification.validUntil || null;
            this.validity = qualification.validity;
            this.isDeleted = qualification.isDeleted;
        }
    }

    @Component({
        components: {
            RequirementsTable, 
            AddQualificationModal, 
            ValidityStatusBadge,
            Badge
        }
    })
    export default class QualificationRequirement extends Vue {
        public static requirementDescriptionTitle = ls.Applications_Requirements_Qualification_Title_QualificationRequirements;
        public static headingDescription = ls.Applications_Requirements_Qualification_Heading_AddingQualification;
        
        @Prop({required: true})
        application!: ApplicationViewModel; // TODO: Constrain this.
        @Prop({required: true})
        requirementFulfillment!: RequirementFulfillmentViewModel;
        @Prop({required: true})
        requirement!: QualificationRequirementViewModel;
        @Prop({required: true})
        requirementValue!: IdentityValueViewModel | null;
        @Prop({required: true})
        actions!: ApplicationActions;

        chosenQualifications: QualificationViewModel[] = [];
        choosableQualifications: QualificationViewModel[] = [];

        chosenLoader = new Loader();
        choosableLoader = new Loader();

        fields: BvTableFieldArray = [
            {
                key: 'speciality',
                label: this.$ls.Applications_Requirements_Qualification_Table_Label_Speciality,
                sortable: false,
                thClass: "w-35"
            },
            {
                key: 'specialityTypeName',
                label: this.$ls.Applications_Requirements_Qualification_Table_Label_SpecialityType,
                sortable: false,
                thClass: "w-15"
            },
            {
                key: 'issuedOn',
                label: this.$ls.Global_Label_IssueDateShort,
                sortable: false,
                thClass: "w-10",
                formatter: (dateString : string | null) => formatDate(dateString) 
            },
            {
                key: 'validUntil',
                label: this.$ls.Global_Label_ValidUntil,
                sortable: false,
                thClass: "w-10",
                formatter: (dateString : string | null) => formatDate(dateString) 
            },
            {
                key: 'validity',
                label: this.$ls.Global_Label_DocumentState,
                sortable: false,
                sortByFormatted: false, 
                thClass: 'w-10'
            },
            {
                key: 'actions',
                label: '',
                sortable: false,
                tdClass: 'table-actions'
            }
        ];
        
        $refs!:{
            addQualificationModal: AddQualificationModal;
        }
        
        created() {
            if (this.requirementValue) {
                new RequirementsClient()
                    .setLoader(this.chosenLoader)
                    .chosenQualifications(this.application.id, this.requirement.id)
                    .then(result => this.chosenQualifications = result);
            }

            if (this.actions.canFillRequirements) {
                new RequirementsClient()
                    .setLoader(this.choosableLoader)
                    .choosable(this.application.id, this.requirement.id)
                    .then(result => this.choosableQualifications = result);
            }
        }

        async choose(tableItem: TableItem) {
            new RequirementsClient().chooseQualification(tableItem.id, this.application.id, this.requirement.id).then(
                () => this.$emit("application-changed"),
                error => this.$emit("error-happened", error, [`<a href="${this.$router.resolve({name: "seafarer-qualifications", params: {seafarerId: this.application.seafarerId}}).href}">${this.$ls.Applications_Requirements_Qualification_Error_AddedQualificationIsInThisList}</a>`]));
        }

        async removeChosen(id: string) {
            new RequirementsClient().removeChosenQualification(id, this.application.id, this.requirement.id).then(
                () => this.$emit("application-changed"),
                error => this.$emit("error-happened", error));
        }
        
        get chosenQualificationTableItems() : TableItem[] {
            if (!this.chosenQualifications)
                return [];
            return this.chosenQualifications.map(x => new QualificationTableItem(x));
        }

        get choosableQualificationsTableItems(): TableItem[] {
            return this.choosableQualifications.map(x => new QualificationTableItem(x))
        }
        
        viewDetails(qualification: QualificationTableItem){
            const routeMap: { [type: string]: string; } = {};
            routeMap[SpecialityType.Educational] = "requirement-educational-qualification-details";
            routeMap[SpecialityType.Training] = "requirement-training-qualification-details";
            this.$router.push({name: routeMap[qualification.specialityType], params:{qualificationId: qualification.id}})
        }
        
        addNewQualification(){
            this.$refs.addQualificationModal.open(this.application.seafarerId);
        }
    }
